(function (app, ng) {
    app.factory("eventCollectionFactory", ["industryStandardsConstant", "$filter",
        function eventCollectionFactory(industryStandardsConstant, $filter) {
            //Convert metrics value to percentage with 1 decimal point if fractional num
            function _getPercentage(value) {
                var _numObj = Number.parseFloat(value);

                if (Number.isInteger(_numObj))
                    return _numObj + '%';

                else return _numObj.toFixed(1) + '%';

            }

            //Convert metrics value to currency with 2 decimal points if fractional num
            function _getCurrency(value) {
                var _numObj = Number.parseFloat(value);
                var _decimal = 2;

                if (Number.isInteger(_numObj))
                    _decimal = 0;

                return $filter('currency')(_numObj, '$', _decimal);
            }

            var collection = [
                {
                    name: 'Cumulative',
                    url: '^.Cumulative',
                    eventTypes: [],
                    performanceArray: []
                },
                {
                    name: "Client Events",
                    url: "^.ClientEvents",
                    eventTypes: ["All", "Client Appreciation Events", "Client Educational Events", "Social Events", "Holiday Events", "Referral Events"],
                    performanceArray: [
                        {
                            name: industryStandardsConstant.clientEvents.responseRate.name,
                            displayName: industryStandardsConstant.clientEvents.responseRate.displayName,
                            icon: industryStandardsConstant.clientEvents.responseRate.icon,
                            standard: {
                                lowerBound: industryStandardsConstant.clientEvents.responseRate.lowerBound,
                                upperBound: industryStandardsConstant.clientEvents.responseRate.upperBound,
                                display: industryStandardsConstant.clientEvents.responseRate.lowerBound + '%' + ' - ' + industryStandardsConstant.clientEvents.responseRate.upperBound + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.lowerBound)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.clientEvents.noShowRate.name,
                            displayName: industryStandardsConstant.clientEvents.noShowRate.displayName,
                            icon: industryStandardsConstant.clientEvents.noShowRate.icon,
                            standard: {
                                lowerBound: industryStandardsConstant.clientEvents.noShowRate.lowerBound,
                                upperBound: industryStandardsConstant.clientEvents.noShowRate.upperBound,
                                display: industryStandardsConstant.clientEvents.noShowRate.lowerBound + '%' + ' - ' + industryStandardsConstant.clientEvents.noShowRate.upperBound + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val <= this.standard.lowerBound)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.clientEvents.appointmentSetRate.name,
                            displayName: industryStandardsConstant.clientEvents.appointmentSetRate.displayName,
                            icon: industryStandardsConstant.clientEvents.appointmentSetRate.icon,
                            standard: {
                                lowerBound: industryStandardsConstant.clientEvents.appointmentSetRate.lowerBound,
                                upperBound: industryStandardsConstant.clientEvents.appointmentSetRate.upperBound,
                                display: industryStandardsConstant.clientEvents.appointmentSetRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.clientEvents.persistencyRate.name,
                            displayName: industryStandardsConstant.clientEvents.persistencyRate.displayName,
                            icon: industryStandardsConstant.clientEvents.persistencyRate.icon,
                            standard: {
                                lowerBound: industryStandardsConstant.clientEvents.persistencyRate.lowerBound,
                                upperBound: industryStandardsConstant.clientEvents.persistencyRate.upperBound,
                                display: industryStandardsConstant.clientEvents.persistencyRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.clientEvents.closeRate.name,
                            displayName: industryStandardsConstant.clientEvents.closeRate.displayName,
                            icon: industryStandardsConstant.clientEvents.closeRate.icon,
                            standard: {
                                lowerBound: industryStandardsConstant.clientEvents.closeRate.lowerBound,
                                upperBound: industryStandardsConstant.clientEvents.closeRate.upperBound,
                                display: industryStandardsConstant.clientEvents.closeRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.clientEvents.roi.name,
                            displayName: industryStandardsConstant.clientEvents.roi.displayName,
                            icon: industryStandardsConstant.clientEvents.roi.icon,
                            standard: {
                                lowerBound: industryStandardsConstant.clientEvents.roi.lowerBound,
                                upperBound: industryStandardsConstant.clientEvents.roi.upperBound,
                                display: industryStandardsConstant.clientEvents.roi.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.clientEvents.averageCaseSize.name,
                            displayName: industryStandardsConstant.clientEvents.averageCaseSize.displayName,
                            icon: industryStandardsConstant.clientEvents.averageCaseSize.icon,
                            standard: {
                                lowerBound: industryStandardsConstant.clientEvents.averageCaseSize.lowerBound,
                                upperBound: industryStandardsConstant.clientEvents.averageCaseSize.upperBound,
                                display: _getCurrency(industryStandardsConstant.clientEvents.averageCaseSize.value)
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getCurrency(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        }
                    ]
                },
                {
                    name: "College Classes",
                    url: "^.CollegeClasses",
                    eventTypes: ["All", "College Courses", "College Courses - Power of Zero"],
                    performanceArray: [
                        {
                            name: industryStandardsConstant.collegeClasses.responseRate.name,
                            displayName: industryStandardsConstant.collegeClasses.responseRate.displayName,
                            icon: industryStandardsConstant.collegeClasses.responseRate.icon,
                            standard: {
                                value: industryStandardsConstant.collegeClasses.responseRate.value,
                                lowerBound: industryStandardsConstant.collegeClasses.responseRate.lowerBound,
                                upperBound: industryStandardsConstant.collegeClasses.responseRate.upperBound,
                                display: industryStandardsConstant.collegeClasses.responseRate.lowerBound + '%' + ' - ' + industryStandardsConstant.collegeClasses.responseRate.upperBound + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.lowerBound)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.collegeClasses.noShowRate.name,
                            displayName: industryStandardsConstant.collegeClasses.noShowRate.displayName,
                            icon: industryStandardsConstant.collegeClasses.noShowRate.icon,
                            standard: {
                                value: industryStandardsConstant.collegeClasses.noShowRate.value,
                                lowerBound: industryStandardsConstant.collegeClasses.noShowRate.lowerBound,
                                upperBound: industryStandardsConstant.collegeClasses.noShowRate.upperBound,
                                display: industryStandardsConstant.collegeClasses.noShowRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val <= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.collegeClasses.appointmentSetRate.name,
                            displayName: industryStandardsConstant.collegeClasses.appointmentSetRate.displayName,
                            icon: industryStandardsConstant.collegeClasses.appointmentSetRate.icon,
                            standard: {
                                value: industryStandardsConstant.collegeClasses.appointmentSetRate.value,
                                lowerBound: industryStandardsConstant.collegeClasses.appointmentSetRate.lowerBound,
                                upperBound: industryStandardsConstant.collegeClasses.appointmentSetRate.upperBound,
                                display: industryStandardsConstant.collegeClasses.appointmentSetRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.collegeClasses.persistencyRate.name,
                            displayName: industryStandardsConstant.collegeClasses.persistencyRate.displayName,
                            icon: industryStandardsConstant.collegeClasses.persistencyRate.icon,
                            standard: {
                                value: industryStandardsConstant.collegeClasses.persistencyRate.value,
                                lowerBound: industryStandardsConstant.collegeClasses.persistencyRate.lowerBound,
                                upperBound: industryStandardsConstant.collegeClasses.persistencyRate.upperBound,
                                display: industryStandardsConstant.collegeClasses.persistencyRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.collegeClasses.closeRate.name,
                            displayName: industryStandardsConstant.collegeClasses.closeRate.displayName,
                            icon: industryStandardsConstant.collegeClasses.closeRate.icon,
                            standard: {
                                value: industryStandardsConstant.collegeClasses.closeRate.value,
                                lowerBound: industryStandardsConstant.collegeClasses.closeRate.lowerBound,
                                upperBound: industryStandardsConstant.collegeClasses.closeRate.upperBound,
                                display: industryStandardsConstant.collegeClasses.closeRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.collegeClasses.roi.name,
                            displayName: industryStandardsConstant.collegeClasses.roi.displayName,
                            icon: industryStandardsConstant.collegeClasses.roi.icon,
                            standard: {
                                value: industryStandardsConstant.collegeClasses.roi.value,
                                lowerBound: industryStandardsConstant.collegeClasses.roi.lowerBound,
                                upperBound: industryStandardsConstant.collegeClasses.roi.upperBound,
                                display: industryStandardsConstant.collegeClasses.roi.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.collegeClasses.averageCaseSize.name,
                            displayName: industryStandardsConstant.collegeClasses.averageCaseSize.displayName,
                            icon: industryStandardsConstant.collegeClasses.averageCaseSize.icon,
                            standard: {
                                value: industryStandardsConstant.collegeClasses.averageCaseSize.value,
                                lowerBound: industryStandardsConstant.collegeClasses.averageCaseSize.lowerBound,
                                upperBound: industryStandardsConstant.collegeClasses.averageCaseSize.upperBound,
                                display: _getCurrency(industryStandardsConstant.collegeClasses.averageCaseSize.value)
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getCurrency(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        }
                    ]
                },
                {
                    name: 'Dinner Seminars',
                    url: '^.DinnerSeminars',
                    eventTypes: ["All", "Dinner Seminars"],
                    performanceArray: [
                        {
                            name: industryStandardsConstant.dinnerSeminars.responseRate.name,
                            displayName: industryStandardsConstant.dinnerSeminars.responseRate.displayName,
                            icon: industryStandardsConstant.dinnerSeminars.responseRate.icon,
                            standard: {
                                value: industryStandardsConstant.dinnerSeminars.responseRate.value,
                                lowerBound: industryStandardsConstant.dinnerSeminars.responseRate.lowerBound,
                                upperBound: industryStandardsConstant.dinnerSeminars.responseRate.upperBound,
                                display: industryStandardsConstant.dinnerSeminars.responseRate.lowerBound + '%' + ' - ' + industryStandardsConstant.dinnerSeminars.responseRate.upperBound + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.lowerBound)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.dinnerSeminars.noShowRate.name,
                            displayName: industryStandardsConstant.dinnerSeminars.noShowRate.displayName,
                            icon: industryStandardsConstant.dinnerSeminars.noShowRate.icon,
                            standard: {
                                value: industryStandardsConstant.dinnerSeminars.noShowRate.value,
                                lowerBound: industryStandardsConstant.dinnerSeminars.noShowRate.lowerBound,
                                upperBound: industryStandardsConstant.dinnerSeminars.noShowRate.upperBound,
                                display: industryStandardsConstant.dinnerSeminars.noShowRate.lowerBound + '%' + ' - ' + industryStandardsConstant.dinnerSeminars.noShowRate.upperBound + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val <= this.standard.upperBound)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.dinnerSeminars.appointmentSetRate.name,
                            displayName: industryStandardsConstant.dinnerSeminars.appointmentSetRate.displayName,
                            icon: industryStandardsConstant.dinnerSeminars.appointmentSetRate.icon,
                            standard: {
                                value: industryStandardsConstant.dinnerSeminars.appointmentSetRate.value,
                                lowerBound: industryStandardsConstant.dinnerSeminars.appointmentSetRate.lowerBound,
                                upperBound: industryStandardsConstant.dinnerSeminars.appointmentSetRate.upperBound,
                                display: industryStandardsConstant.dinnerSeminars.appointmentSetRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.dinnerSeminars.persistencyRate.name,
                            displayName: industryStandardsConstant.dinnerSeminars.persistencyRate.displayName,
                            icon: industryStandardsConstant.dinnerSeminars.persistencyRate.icon,
                            standard: {
                                value: industryStandardsConstant.dinnerSeminars.persistencyRate.value,
                                lowerBound: industryStandardsConstant.dinnerSeminars.persistencyRate.lowerBound,
                                upperBound: industryStandardsConstant.dinnerSeminars.persistencyRate.upperBound,
                                display: industryStandardsConstant.dinnerSeminars.persistencyRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.dinnerSeminars.closeRate.name,
                            displayName: industryStandardsConstant.dinnerSeminars.closeRate.displayName,
                            icon: industryStandardsConstant.dinnerSeminars.closeRate.icon,
                            standard: {
                                value: industryStandardsConstant.dinnerSeminars.closeRate.value,
                                lowerBound: industryStandardsConstant.dinnerSeminars.closeRate.lowerBound,
                                upperBound: industryStandardsConstant.dinnerSeminars.closeRate.upperBound,
                                display: industryStandardsConstant.dinnerSeminars.closeRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.dinnerSeminars.roi.name,
                            displayName: industryStandardsConstant.dinnerSeminars.roi.displayName,
                            icon: industryStandardsConstant.dinnerSeminars.roi.icon,
                            standard: {
                                value: industryStandardsConstant.dinnerSeminars.roi.value,
                                lowerBound: industryStandardsConstant.dinnerSeminars.roi.lowerBound,
                                upperBound: industryStandardsConstant.dinnerSeminars.roi.upperBound,
                                display: industryStandardsConstant.dinnerSeminars.roi.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.dinnerSeminars.averageCaseSize.name,
                            displayName: industryStandardsConstant.dinnerSeminars.averageCaseSize.displayName,
                            icon: industryStandardsConstant.dinnerSeminars.averageCaseSize.icon,
                            standard: {
                                value: industryStandardsConstant.dinnerSeminars.averageCaseSize.value,
                                lowerBound: industryStandardsConstant.dinnerSeminars.averageCaseSize.lowerBound,
                                upperBound: industryStandardsConstant.dinnerSeminars.averageCaseSize.upperBound,
                                display: _getCurrency(industryStandardsConstant.dinnerSeminars.averageCaseSize.value)
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getCurrency(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        }
                    ]
                },
                {
                    name: 'Social Security Seminars',
                    url: '^.SSSeminars',
                    eventTypes: ["All", "Social Security Seminars"],
                    performanceArray: [
                        {
                            name: industryStandardsConstant.sSSeminars.responseRate.name,
                            displayName: industryStandardsConstant.sSSeminars.responseRate.displayName,
                            icon: industryStandardsConstant.sSSeminars.responseRate.icon,
                            standard: {
                                value: industryStandardsConstant.sSSeminars.responseRate.value,
                                lowerBound: industryStandardsConstant.sSSeminars.responseRate.lowerBound,
                                upperBound: industryStandardsConstant.sSSeminars.responseRate.upperBound,
                                display: industryStandardsConstant.sSSeminars.responseRate.lowerBound + '%' + ' - ' + industryStandardsConstant.sSSeminars.responseRate.upperBound + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.lowerBound)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.sSSeminars.noShowRate.name,
                            displayName: industryStandardsConstant.sSSeminars.noShowRate.displayName,
                            icon: industryStandardsConstant.sSSeminars.noShowRate.icon,
                            standard: {
                                value: industryStandardsConstant.sSSeminars.noShowRate.value,
                                lowerBound: industryStandardsConstant.sSSeminars.noShowRate.lowerBound,
                                upperBound: industryStandardsConstant.sSSeminars.noShowRate.upperBound,
                                display: industryStandardsConstant.sSSeminars.noShowRate.lowerBound + '%' + ' - ' + industryStandardsConstant.sSSeminars.noShowRate.upperBound + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val <= this.standard.upperBound)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.sSSeminars.appointmentSetRate.name,
                            displayName: industryStandardsConstant.sSSeminars.appointmentSetRate.displayName,
                            icon: industryStandardsConstant.sSSeminars.appointmentSetRate.icon,
                            standard: {
                                value: industryStandardsConstant.sSSeminars.appointmentSetRate.value,
                                lowerBound: industryStandardsConstant.sSSeminars.appointmentSetRate.lowerBound,
                                upperBound: industryStandardsConstant.sSSeminars.appointmentSetRate.upperBound,
                                display: industryStandardsConstant.sSSeminars.appointmentSetRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.sSSeminars.persistencyRate.name,
                            displayName: industryStandardsConstant.sSSeminars.persistencyRate.displayName,
                            icon: industryStandardsConstant.sSSeminars.persistencyRate.icon,
                            standard: {
                                value: industryStandardsConstant.sSSeminars.persistencyRate.value,
                                lowerBound: industryStandardsConstant.sSSeminars.persistencyRate.lowerBound,
                                upperBound: industryStandardsConstant.sSSeminars.persistencyRate.upperBound,
                                display: industryStandardsConstant.sSSeminars.persistencyRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.sSSeminars.closeRate.name,
                            displayName: industryStandardsConstant.sSSeminars.closeRate.displayName,
                            icon: industryStandardsConstant.sSSeminars.closeRate.icon,
                            standard: {
                                value: industryStandardsConstant.sSSeminars.closeRate.value,
                                lowerBound: industryStandardsConstant.sSSeminars.closeRate.lowerBound,
                                upperBound: industryStandardsConstant.sSSeminars.closeRate.upperBound,
                                display: industryStandardsConstant.sSSeminars.closeRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.sSSeminars.roi.name,
                            displayName: industryStandardsConstant.sSSeminars.roi.displayName,
                            icon: industryStandardsConstant.sSSeminars.roi.icon,
                            standard: {
                                value: industryStandardsConstant.sSSeminars.roi.value,
                                lowerBound: industryStandardsConstant.sSSeminars.roi.lowerBound,
                                upperBound: industryStandardsConstant.sSSeminars.roi.upperBound,
                                display: industryStandardsConstant.sSSeminars.roi.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.sSSeminars.averageCaseSize.name,
                            displayName: industryStandardsConstant.sSSeminars.averageCaseSize.displayName,
                            icon: industryStandardsConstant.sSSeminars.averageCaseSize.icon,
                            standard: {
                                value: industryStandardsConstant.sSSeminars.averageCaseSize.value,
                                lowerBound: industryStandardsConstant.sSSeminars.averageCaseSize.lowerBound,
                                upperBound: industryStandardsConstant.sSSeminars.averageCaseSize.upperBound,
                                display: _getCurrency(industryStandardsConstant.sSSeminars.averageCaseSize.value)
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getCurrency(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        }
                    ]
                },
                {
                    name: 'Public Educational Workshops',
                    url: '^.PEWorkshops',
                    eventTypes: ["All", "Public Edu Workshops"],
                    performanceArray: [
                        {
                            name: industryStandardsConstant.publicEduWorkshops.responseRate.name,
                            displayName: industryStandardsConstant.publicEduWorkshops.responseRate.displayName,
                            icon: industryStandardsConstant.publicEduWorkshops.responseRate.icon,
                            standard: {
                                value: industryStandardsConstant.publicEduWorkshops.responseRate.value,
                                lowerBound: industryStandardsConstant.publicEduWorkshops.responseRate.lowerBound,
                                upperBound: industryStandardsConstant.publicEduWorkshops.responseRate.upperBound,
                                display: industryStandardsConstant.publicEduWorkshops.responseRate.lowerBound + '%' + ' - ' + industryStandardsConstant.publicEduWorkshops.responseRate.upperBound + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.lowerBound)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.publicEduWorkshops.noShowRate.name,
                            displayName: industryStandardsConstant.publicEduWorkshops.noShowRate.displayName,
                            icon: industryStandardsConstant.publicEduWorkshops.noShowRate.icon,
                            standard: {
                                value: industryStandardsConstant.publicEduWorkshops.noShowRate.value,
                                lowerBound: industryStandardsConstant.publicEduWorkshops.noShowRate.lowerBound,
                                upperBound: industryStandardsConstant.publicEduWorkshops.noShowRate.upperBound,
                                display: industryStandardsConstant.publicEduWorkshops.noShowRate.lowerBound + '%' + ' - ' + industryStandardsConstant.publicEduWorkshops.noShowRate.upperBound + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val <= this.standard.upperBound)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.publicEduWorkshops.appointmentSetRate.name,
                            displayName: industryStandardsConstant.publicEduWorkshops.appointmentSetRate.displayName,
                            icon: industryStandardsConstant.publicEduWorkshops.appointmentSetRate.icon,
                            standard: {
                                value: industryStandardsConstant.publicEduWorkshops.appointmentSetRate.value,
                                lowerBound: industryStandardsConstant.publicEduWorkshops.appointmentSetRate.lowerBound,
                                upperBound: industryStandardsConstant.publicEduWorkshops.appointmentSetRate.upperBound,
                                display: industryStandardsConstant.publicEduWorkshops.appointmentSetRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.publicEduWorkshops.persistencyRate.name,
                            displayName: industryStandardsConstant.publicEduWorkshops.persistencyRate.displayName,
                            icon: industryStandardsConstant.publicEduWorkshops.persistencyRate.icon,
                            standard: {
                                value: industryStandardsConstant.publicEduWorkshops.persistencyRate.value,
                                lowerBound: industryStandardsConstant.publicEduWorkshops.persistencyRate.lowerBound,
                                upperBound: industryStandardsConstant.publicEduWorkshops.persistencyRate.upperBound,
                                display: industryStandardsConstant.publicEduWorkshops.persistencyRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.publicEduWorkshops.closeRate.name,
                            displayName: industryStandardsConstant.publicEduWorkshops.closeRate.displayName,
                            icon: industryStandardsConstant.publicEduWorkshops.closeRate.icon,
                            standard: {
                                value: industryStandardsConstant.publicEduWorkshops.closeRate.value,
                                lowerBound: industryStandardsConstant.publicEduWorkshops.closeRate.lowerBound,
                                upperBound: industryStandardsConstant.publicEduWorkshops.closeRate.upperBound,
                                display: industryStandardsConstant.publicEduWorkshops.closeRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.publicEduWorkshops.roi.name,
                            displayName: industryStandardsConstant.publicEduWorkshops.roi.displayName,
                            icon: industryStandardsConstant.publicEduWorkshops.roi.icon,
                            standard: {
                                value: industryStandardsConstant.publicEduWorkshops.roi.value,
                                lowerBound: industryStandardsConstant.publicEduWorkshops.roi.lowerBound,
                                upperBound: industryStandardsConstant.publicEduWorkshops.roi.upperBound,
                                display: industryStandardsConstant.publicEduWorkshops.roi.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.publicEduWorkshops.averageCaseSize.name,
                            displayName: industryStandardsConstant.publicEduWorkshops.averageCaseSize.displayName,
                            icon: industryStandardsConstant.publicEduWorkshops.averageCaseSize.icon,
                            standard: {
                                value: industryStandardsConstant.publicEduWorkshops.averageCaseSize.value,
                                lowerBound: industryStandardsConstant.publicEduWorkshops.averageCaseSize.lowerBound,
                                upperBound: industryStandardsConstant.publicEduWorkshops.averageCaseSize.upperBound,
                                display: _getCurrency(industryStandardsConstant.publicEduWorkshops.averageCaseSize.value)
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getCurrency(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        }
                    ]
                },
                {
                    name: 'Social Security Seminars',
                    url: '^.SSSeminars',
                    eventTypes: ["All", "Referral Events"],
                    performanceArray: [
                        {
                            name: industryStandardsConstant.referrals.responseRate.name,
                            displayName: industryStandardsConstant.referrals.responseRate.displayName,
                            icon: industryStandardsConstant.referrals.responseRate.icon,
                            standard: {
                                value: industryStandardsConstant.referrals.responseRate.value,
                                lowerBound: industryStandardsConstant.referrals.responseRate.lowerBound,
                                upperBound: industryStandardsConstant.referrals.responseRate.upperBound,
                                display: industryStandardsConstant.referrals.responseRate.lowerBound + '%' + ' - ' + industryStandardsConstant.referrals.responseRate.upperBound + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.lowerBound)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.referrals.noShowRate.name,
                            displayName: industryStandardsConstant.referrals.noShowRate.displayName,
                            icon: industryStandardsConstant.referrals.noShowRate.icon,
                            standard: {
                                value: industryStandardsConstant.referrals.noShowRate.value,
                                lowerBound: industryStandardsConstant.referrals.noShowRate.lowerBound,
                                upperBound: industryStandardsConstant.referrals.noShowRate.upperBound,
                                display: industryStandardsConstant.referrals.noShowRate.lowerBound + '%' + ' - ' + industryStandardsConstant.referrals.noShowRate.upperBound + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val <= this.standard.upperBound)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.referrals.appointmentSetRate.name,
                            displayName: industryStandardsConstant.referrals.appointmentSetRate.displayName,
                            icon: industryStandardsConstant.referrals.appointmentSetRate.icon,
                            standard: {
                                value: industryStandardsConstant.referrals.appointmentSetRate.value,
                                lowerBound: industryStandardsConstant.referrals.appointmentSetRate.lowerBound,
                                upperBound: industryStandardsConstant.referrals.appointmentSetRate.upperBound,
                                display: industryStandardsConstant.referrals.appointmentSetRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= industryStandardsConstant.referrals.appointmentSetRate.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.referrals.persistencyRate.name,
                            displayName: industryStandardsConstant.referrals.persistencyRate.displayName,
                            icon: industryStandardsConstant.referrals.persistencyRate.icon,
                            standard: {
                                value: industryStandardsConstant.referrals.persistencyRate.value,
                                lowerBound: industryStandardsConstant.referrals.persistencyRate.lowerBound,
                                upperBound: industryStandardsConstant.referrals.persistencyRate.upperBound,
                                display: industryStandardsConstant.referrals.persistencyRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.referrals.closeRate.name,
                            displayName: industryStandardsConstant.referrals.closeRate.displayName,
                            icon: industryStandardsConstant.referrals.closeRate.icon,
                            standard: {
                                value: industryStandardsConstant.referrals.closeRate.value,
                                lowerBound: industryStandardsConstant.referrals.closeRate.lowerBound,
                                upperBound: industryStandardsConstant.referrals.closeRate.upperBound,
                                display: industryStandardsConstant.referrals.closeRate.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.referrals.roi.name,
                            displayName: industryStandardsConstant.referrals.roi.displayName,
                            icon: industryStandardsConstant.referrals.roi.icon,
                            standard: {
                                value: industryStandardsConstant.referrals.roi.value,
                                lowerBound: industryStandardsConstant.referrals.roi.lowerBound,
                                upperBound: industryStandardsConstant.referrals.roi.upperBound,
                                display: industryStandardsConstant.referrals.roi.value + '%'
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getPercentage(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        },
                        {
                            name: industryStandardsConstant.referrals.averageCaseSize.name,
                            displayName: industryStandardsConstant.referrals.averageCaseSize.displayName,
                            icon: industryStandardsConstant.referrals.averageCaseSize.icon,
                            standard: {
                                value: industryStandardsConstant.referrals.averageCaseSize.value,
                                lowerBound: industryStandardsConstant.referrals.averageCaseSize.lowerBound,
                                upperBound: industryStandardsConstant.referrals.averageCaseSize.upperBound,
                                display: _getCurrency(industryStandardsConstant.referrals.averageCaseSize.value)
                            },
                            value: 0,
                            displayValue: function (val) {
                                return _getCurrency(val);
                            },
                            isGood: function (val) {
                                if (val >= this.standard.value)
                                    return true;
                                return false;
                            }
                        }
                    ]
                }
            ];

            return collection;
        }
    ]

    );
})(window.app, window.angular);